import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { Icon } from '@iconify/react';
import { useDispatch } from "react-redux";
import { logout } from "../../../../actions/customer";

const DashboardContent = () => {
  const dispatch = useDispatch();

  const onLogout = () => {
    dispatch(logout());
  };

  return (
    <div className='dashboard'>
      <Row>
        
        <Col sm={4}>
          <Link to="/candidate/job/application/manage" className="my-card">
            <Icon icon={"akar-icons:paper"} color="#766df4" style={{marginRight: 10}} fontSize={22} />
            Manage Job Applications
          </Link>
        </Col>

        <Col sm={4}>
          <Link to="/candidate/job/bookmark/manage" className="my-card">
            <Icon icon={"bi:bookmark-check"} color="#766df4" style={{marginRight: 10}} fontSize={22} />

            Manage Bookmarked Jobs
          </Link>
        </Col>

        <Col sm={4}>
          <Link to="/candidate/profile/view" className="my-card">
            <Icon icon={"iconoir:profile-circled"} color="#766df4" style={{marginRight: 10}} fontSize={22} />

            My Profile
          </Link>
        </Col>

        <Col sm={4}>
          <Link to="/" onClick={onLogout} className="my-card">
            <Icon icon={"akar-icons:sign-out"} color="#766df4" style={{marginRight: 10}} fontSize={22} />
            Log Out
          </Link>
        </Col>

      </Row>
    </div>
  )
}

export default DashboardContent